import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';

@Injectable({
  providedIn: 'root'
})
export class ToastService {

  constructor(private messageService: MessageService) {}

  add(notification: any) {
    this.messageService.add({
      severity: notification.type === 'success' ? 'success' : notification.type === 'error' ? 'error' : 'info',
      summary: notification.type === 'success' ? 'Éxito' : notification.type === 'error' ? 'Error' : 'Info',
      detail: notification.message,
      life: 4000
    });
  }
}
